import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';
import {
    checkVerificationStatus,
    GOCARDLESS_VERIFICATION_STATUS_REQUEST, GOCARDLESS_VERIFICATION_STATUS_SUCCESS, GOCARDLESS_VERIFICATION_STATUS_FAILURE
} from './actions';
import { withTranslation, Trans } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';

class VerificationStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: '',
            statusError: false,
            statusErrorMessage: ''
        };
    }

    componentDidMount() {
        const { paymentConfigurationId } = this.props;
        this.props.checkVerificationStatus({ paymentConfigurationId },
            response => this.setState({ statusError: false, status: response.status }),
            errorResponse => this.setState({ statusError: true, statusErrorMessage: errorResponse }));
    }

    renderVerificationInfo() {
        const { useSandbox, t } = this.props;
        const { status, statusError, statusErrorMessage } = this.state;

        const onboardingUrl = useSandbox ? 'https://verify-sandbox.gocardless.com' : 'https://verify.gocardless.com';

        let alertStyle = 'warning';
        let header = t('GoCardless_VerificationStatus_Checking');
        let description = '';

        if (statusError) {
            alertStyle = 'danger';
            header = t('GoCardless_VerificationStatus_Error');
            description = <Trans i18nKey='GoCardless_VerificationStatus_Error_Description'>
                <b>{{ statusErrorMessage }}</b>
            </Trans>;
        } else {
            switch (status.toLowerCase()) {
                case 'successful':
                    alertStyle = 'success';
                    header = t('GoCardless_VerificationStatus_Successful');
                    description = t('GoCardless_VerificationStatus_Successful_Description');
                    break;
                case 'in_review':
                    alertStyle = 'warning';
                    header = t('GoCardless_VerificationStatus_InReview');
                    description = t('GoCardless_VerificationStatus_InReview_Description');
                    break;
                case 'action_required':
                    alertStyle = 'warning';
                    header = t('GoCardless_VerificationStatus_ActionRequired');
                    description = <Trans i18nKey='GoCardless_VerificationStatus_ActionRequired_Description'>
                        <a href={onboardingUrl} style={{ fontWeight: 'bold' }}>Click here</a> to start verification process.
				</Trans>;
                    break;
            }
        }

        return <Alert bsStyle={alertStyle}>
            <div style={{ marginBottom: '10px' }}><strong>{header}</strong></div>
            <div>{description}</div>
        </Alert>;
    }

    render() {
        return <ReduxBlockUi block={GOCARDLESS_VERIFICATION_STATUS_REQUEST} unblock={[GOCARDLESS_VERIFICATION_STATUS_SUCCESS, GOCARDLESS_VERIFICATION_STATUS_FAILURE]} renderChildren>
            {this.renderVerificationInfo()}
        </ReduxBlockUi >;
    }
}

export default connect(null, {
    checkVerificationStatus
})(withTranslation()(VerificationStatus));